import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'
import { useToast } from '@/lib/hooks/use-toast'
import api from '@/lib/api'
import { AxiosError } from 'axios'

interface UpdateStatusParams {
  comissao_user: number
  comissao_user_escrita: string
  id: string
}

export function useUpdateUserComissao({ onSuccess }: { onSuccess: () => void }) {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async ({ comissao_user, comissao_user_escrita, id }: UpdateStatusParams) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      if (!id) throw new Error('ID do usuário para alterar ausente')
      console.log(`comissa `, comissao_user, comissao_user_escrita, id)
      await api.patch(
        `/user/comissao`,
        {
          comissao_user,
          comissao_user_escrita,
          id
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
    },
    onSuccess: () => {
      onSuccess()
      queryClient.refetchQueries({ queryKey: ['user'] })
      queryClient.refetchQueries({ queryKey: ['gerente'] })
      toast({
        title: 'Sucesso',
        description: 'Comissão do usuário atualizado com sucesso!'
      })
    },
    onError: (error: unknown) => {
      console.error('Erro ao atualizar o status do usuário:', error)
      let message = ''

      if (error instanceof Error) message = error.message
      if (error instanceof AxiosError) {
        switch (error.response?.status) {
          case 404:
            message = 'Usuário não encontrado'
            break
          default:
            message = 'Erro desconhecido'
        }
      }

      toast({
        title: 'Erro',
        description: `Erro ao atualizar o status do usuário: ${message}`,
        variant: 'destructive'
      })
    }
  })
}
